import { Chip, ChipProps } from "@mui/material";

const SquareChip = ({ sx, ...props }: ChipProps) => {
  return (
    <Chip
      sx={{
        fontSize: "11px",
        fontWeight: "700",
        backgroundColor: "background.paper",
        color: "text.primary",
        px: 1,
        py: 0.5,
        borderRadius: 1,
        ...sx,
      }}
      {...props}
    />
  );
};

export default SquareChip;
